"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'task.taskDetail.title',
        defaultMessage: 'Task detail',
        description: 'Title for task detail in small',
    },
    detailNameSuffix: {
        id: 'task.taskDetail.detailNameSuffix',
        defaultMessage: 'Detail name',
        description: 'Detail name suffix',
    },
    description: {
        id: 'task.taskDetail.description',
        defaultMessage: 'Manage your tasks here.',
        description: 'Task detail description',
    },
    taskDetailsSectionDescription: {
        id: 'task.taskDetails.section.taskDetails.description',
        defaultMessage: 'Information about field and task',
        description: 'Task details section description',
    },
    machinesSectionDescription: {
        id: 'task.taskDetails.section.machines.description',
        defaultMessage: 'Information about machines',
        description: 'Machines section description',
    },
    implementsSectionDescription: {
        id: 'task.taskDetails.section.implements.description',
        defaultMessage: 'Information about implements',
        description: 'Implements section description',
    },
    teamSectionDescription: {
        id: 'task.taskDetails.section.team.description',
        defaultMessage: 'Information about team member.',
        description: 'Team section description',
    },
    taskDescription: {
        id: 'task.taskDetails.taskDescription',
        defaultMessage: 'Task description',
        description: 'Task detail task description',
    },
    selectSecondImplement: {
        id: 'task.taskDetails.selectSecondImplement',
        defaultMessage: 'Select second implement',
        description: 'Select second implement button',
    },
});
exports.default = messages;
